// "Sign without consultant" (Approval Settings; Chris McCarty, SLCC, 2026-10-19).
// Shared by the Pay Request, PCO and Change Order pages. The page's own sign
// pop-up switches into this mode: a warning naming the consultant, its own
// title and button; the sign request then carries skip_consultant=1.

// Whether the owner-side signer gets the button: the company allows it, the
// contractor has signed, the consultant hasn't, and it still needs three.
export function canSignWithoutConsultant({ allowed, ownerApprover, myRoleSigned, contractorSigned, consultantSigned, requiredSigs }) {
  return !!(allowed && ownerApprover && !myRoleSigned && contractorSigned && !consultantSigned && requiredSigs >= 3)
}

export function setSkipConsultantMode(controller, on) {
  controller._skipConsultant = on
  if (!controller.hasSkipConsultantNoteTarget) return

  const note = controller.skipConsultantNoteTarget
  note.classList.toggle("hidden", !on)
  if (controller.hasSignTitleTarget) swapText(controller.signTitleTarget, on, note.dataset.title)
  if (controller.hasSignConfirmBtnTarget) swapText(controller.signConfirmBtnTarget, on, note.dataset.button)
}

// Adds skip_consultant to the sign request when the pop-up was opened that
// way, and leaves the pop-up in its normal mode again.
export function withSkipConsultant(controller, params) {
  const out = controller._skipConsultant ? { ...params, skip_consultant: "1" } : params
  setSkipConsultantMode(controller, false)
  return out
}

function swapText(el, on, text) {
  if (el.dataset.normalText === undefined) el.dataset.normalText = el.textContent
  el.textContent = on ? text : el.dataset.normalText
}
